import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const steps = [{
  id: 1,
  label: 'STEP 01',
  title: 'Search by location and category on Openmart',
  description: "Enter a location and business category to start scraping. Openmart pulls every matching business from Google Maps — including ones that don't show up in basic searches.",
  image: 'https://cdn.magicpatterns.com/uploads/gV7JHHXgbCBdaBrQXT1vTQ/Search_Filter.gif',
  alt: 'Openmart Google Maps scraper search interface with location and category filters'
}, {
  id: 2,
  label: 'STEP 02',
  title: 'Extract full business profiles',
  description: 'Automatically extract business name, address, phone, website, ratings, reviews, hours, and more from every Google Maps listing. All data is structured and ready to use.',
  image: 'https://cdn.magicpatterns.com/uploads/bLGirWUvre1eghbxa5NnfV/DataProfile_Results.gif',
  alt: 'Openmart showing extracted business profiles with full contact details from Google Maps'
}, {
  id: 3,
  label: 'STEP 03',
  title: 'Export or enrich with owner contacts',
  description: 'Download your scraped data as CSV, or go further — enrich each business with verified owner emails, direct phone numbers, and tech stack detection for personalized outreach.',
  image: 'https://cdn.magicpatterns.com/uploads/rVM4aRBJZ2GReXm9ucPQ7R/ExportCRM_Sync.gif',
  alt: 'Openmart export and enrichment options for scraped Google Maps data'
}];
export function ScraperProductTour() {
  return <section className="py-40 bg-white relative overflow-hidden" data-id="element-1638">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1639">
        <div className="text-center max-w-3xl mx-auto mb-32" data-id="element-1640">
          <div className="text-sm font-bold text-blue-600 tracking-widest uppercase mb-4" data-id="element-1641">
            Product Tour
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight tracking-tight" data-id="element-1642">
            See the <span className="text-blue-600" data-id="element-1643">product in action</span>
          </h2>
          <p className="text-xl text-slate-500 leading-relaxed" data-id="element-1644">
            From Google Maps search to structured business data in minutes.
          </p>
        </div>

        <div className="space-y-36 md:space-y-52" data-id="element-1645">
          {steps.map((step, index) => {
          const isEven = index % 2 !== 0;
          return <div key={step.id} className={`flex flex-col ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-16 lg:gap-28 items-center`} data-id="element-1646">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-5/12 space-y-8" data-id="element-1647">
                  <div className="text-sm font-bold text-slate-400 tracking-widest uppercase" data-id="element-1648">
                    {step.label}
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight leading-tight" data-id="element-1649">
                    {step.title}
                  </h3>
                  <p className="text-lg text-slate-500 leading-relaxed" data-id="element-1650">
                    {step.description}
                  </p>
                  <div className="pt-2" data-id="element-1651">
                    <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-blue-600 font-semibold hover:text-blue-700 transition-colors group" data-id="element-1652">
                      Try for free
                      <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-1653" />
                    </a>
                  </div>
                </motion.div>

                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-7/12" data-id="element-1654">
                  <div className="w-full rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5" data-id="element-1655">
                    <img src={step.image} alt={step.alt} className="w-full h-auto block" loading="lazy" data-id="element-1656" />
                  </div>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}